package org.example.site_web.content


data class WorkingTogetherData(val title: String, val shortDescriptor: String, val details: String)

val WorkingTogetherContentMap = mapOf<String, WorkingTogetherData>(
    "MEETING" to  WorkingTogetherData("Rendez-vous conseil",
                        "Donnez de la perspective à vos idées !",
                        "Pendant une matinée/un après-midi échangeons sur vos idées et problématiques." +
                        "\r\n\r\nSe donner le temps d’échanger et de commencer à approfondir les sujets et les pistes d’améliorations."+
                        "\r\n\r\nC’est un échange confidentiel, offert et sans engagement."),

    "BOOSTER" to  WorkingTogetherData("Formule Booster",
        "Il est temps de décoller !",
        "Un développement ciblé et intensif qui permet de concrétiser une idée." +
        "\r\n\r\nLorsque le niveau de maturation est déjà suffisant, définir une période intensive de développement en forte interaction"+
        " pour atteindre un résultat opérationnel."),

    "PROJECT" to  WorkingTogetherData("Formule Projet",
        "Une solution rentable à portée de main !",
        "Un accompagnement de la formulation du besoin jusqu’aux tests de recettes.")
    )

